// ---------------------------------------------------------------------------
// Icon registry — every icon is an SVG exported from the Figma design
// (assets/icons/), used as-is. `size` is the asset's own root width/height,
// which is the size the design places it at.
//
// Most are rendered through a CSS mask (see .icon in styles.css) so one asset
// can follow the text colour of its context — a nav item turning white when
// active, a menu item turning red when destructive. The asset itself is never
// edited; the mask only takes its shape.
// ---------------------------------------------------------------------------

import alertQuestion from '../assets/icons/alert-question.svg';
import arrowLeft from '../assets/icons/arrow-left.svg';
import breadcrumbChevron from '../assets/icons/breadcrumb-chevron.svg';
import checkCircle from '../assets/icons/check-circle.svg';
import chevronDown from '../assets/icons/chevron-down.svg';
import chevronLeft from '../assets/icons/chevron-left.svg';
import chevronRight from '../assets/icons/chevron-right.svg';
import cpu from '../assets/icons/cpu.svg';
import drawerClose from '../assets/icons/drawer-close.svg';
import emptyBox from '../assets/icons/empty-box.svg';
import kpiAi from '../assets/icons/kpi-ai.svg';
import kpiBuilding from '../assets/icons/kpi-building.svg';
import kpiProjects from '../assets/icons/kpi-projects.svg';
import kpiTrendUp from '../assets/icons/kpi-trend-up.svg';
import kpiUsers from '../assets/icons/kpi-users.svg';
import logOut from '../assets/icons/log-out.svg';
import logoBox from '../assets/icons/logo-box.svg';
import menuDeactivate from '../assets/icons/menu-deactivate.svg';
import menuEdit from '../assets/icons/menu-edit.svg';
import menuProjects from '../assets/icons/menu-projects.svg';
import menuUsers from '../assets/icons/menu-users.svg';
import menuView from '../assets/icons/menu-view.svg';
import modalQuestion from '../assets/icons/modal-question.svg';
import modalRole from '../assets/icons/modal-role.svg';
import moreHorizontal from '../assets/icons/more-horizontal.svg';
import moreVertical from '../assets/icons/more-vertical.svg';
import navDashboard from '../assets/icons/nav-dashboard.svg';
import navOrganisations from '../assets/icons/nav-organisations.svg';
import navProjects from '../assets/icons/nav-projects.svg';
import navTrials from '../assets/icons/nav-trials.svg';
import navUsers from '../assets/icons/nav-users.svg';
import pencil from '../assets/icons/pencil.svg';
import plus from '../assets/icons/plus.svg';
import profileChevron from '../assets/icons/profile-chevron.svg';
import search from '../assets/icons/search.svg';
import selectArrow from '../assets/icons/select-arrow.svg';
import shieldAlert from '../assets/icons/shield-alert.svg';
import timelineNode from '../assets/icons/timeline-node.svg';
import timelineNodeLast from '../assets/icons/timeline-node-last.svg';
import trendingUp from '../assets/icons/trending-up.svg';

/** name → { url, w, h } — w/h are the SVG root's own width/height. */
export const ICONS = {
  'alert-question': { url: alertQuestion, w: 16, h: 16 },
  'arrow-left': { url: arrowLeft, w: 16, h: 16 },
  'breadcrumb-chevron': { url: breadcrumbChevron, w: 14, h: 14 },
  'check-circle': { url: checkCircle, w: 12, h: 12 },
  'chevron-down': { url: chevronDown, w: 14, h: 14 },
  'chevron-left': { url: chevronLeft, w: 16, h: 16 },
  'chevron-right': { url: chevronRight, w: 16, h: 16 },
  cpu: { url: cpu, w: 12, h: 12 },
  'drawer-close': { url: drawerClose, w: 22, h: 22 },
  'empty-box': { url: emptyBox, w: 80, h: 80 },
  'kpi-ai': { url: kpiAi, w: 16, h: 16 },
  'kpi-building': { url: kpiBuilding, w: 16, h: 16 },
  'kpi-projects': { url: kpiProjects, w: 16, h: 16 },
  'kpi-trend-up': { url: kpiTrendUp, w: 12, h: 12 },
  'kpi-users': { url: kpiUsers, w: 16, h: 16 },
  'log-out': { url: logOut, w: 14, h: 14 },
  'logo-box': { url: logoBox, w: 18, h: 18 },
  'menu-deactivate': { url: menuDeactivate, w: 14, h: 14 },
  'menu-edit': { url: menuEdit, w: 14, h: 14 },
  'menu-projects': { url: menuProjects, w: 14, h: 14 },
  'menu-users': { url: menuUsers, w: 14, h: 14 },
  'menu-view': { url: menuView, w: 14, h: 14 },
  'modal-question': { url: modalQuestion, w: 24, h: 24 },
  'modal-role': { url: modalRole, w: 24, h: 24 },
  'more-horizontal': { url: moreHorizontal, w: 16, h: 16 },
  'more-vertical': { url: moreVertical, w: 18, h: 18 },
  'nav-dashboard': { url: navDashboard, w: 18, h: 18 },
  'nav-organisations': { url: navOrganisations, w: 18, h: 18 },
  'nav-projects': { url: navProjects, w: 18, h: 18 },
  'nav-trials': { url: navTrials, w: 14, h: 14 },
  'nav-users': { url: navUsers, w: 18, h: 18 },
  pencil: { url: pencil, w: 14, h: 14 },
  plus: { url: plus, w: 16, h: 16 },
  'profile-chevron': { url: profileChevron, w: 14, h: 14 },
  search: { url: search, w: 16, h: 16 },
  'select-arrow': { url: selectArrow, w: 16, h: 16 },
  'shield-alert': { url: shieldAlert, w: 14, h: 14 },
  'timeline-node': { url: timelineNode, w: 16, h: 50 },
  'timeline-node-last': { url: timelineNodeLast, w: 16, h: 10 },
  'trending-up': { url: trendingUp, w: 12, h: 12 },
};
